var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgELearning(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 25.504h32v1.568c0 .064-.128.224-1.216.352l-.192.032L28.16 28H3.968l-2.432-.544C.128 27.296 0 27.104 0 27.072v-1.568zM27.872 4.992c.288 0 .544.224.576.512l.032.096v18.976H3.488V5.6c0-.32.224-.544.512-.608h23.872zm-1.6 2.688H5.696v14.464h20.576V7.68zm-5.312 7.168v3.712l-.064.064c-.32.256-1.568 1.056-4.896 1.056-3.552 0-4.736-.896-4.928-1.088l-.032-.032v-3.712l4.16 1.312c.448.128.928.16 1.408.032l.192-.032 4.16-1.312zM8 17.472l.416-.768V13.76l.544.224v2.72l.416.768v.896H8v-.896zm7.072-6.848c.448-.128 1.152-.128 1.664-.032l.192.032 6.816 2.08c.48.128.512.352.096.512l-.096.032-6.816 2.048c-.448.16-1.152.16-1.664.064l-.192-.064-6.816-2.048c-.48-.128-.512-.384-.096-.512l.096-.032 6.816-2.08z"
  })));
}

export default SvgELearning;